import { ReactElement, useMemo } from "react";

import { SvText } from "@/components";
import { SeatDataType } from "@/domain/models.tsx";

type SvSeatsChartProps = {
  data: SeatDataType[];
};

export const SvSeatsChart = ({ data }: SvSeatsChartProps) => {
  const seatBlocks = useMemo(() => {
    const output: ReactElement[] = [];

    data
      .sort((a, b) => b.seats - a.seats)
      .forEach(row => {
        for (let i = 0; i < row.seats; i++) {
          output.push(
            <div
              className="size-[10px] shrink-0 grow-0 rounded-xs md:size-[15px]"
              style={{ backgroundColor: `#${row.color}` }}
              key={row.id + i}
            />,
          );
        }
      });

    return output;
  }, [data]);

  return (
    <div className="@container">
      <div className="font-inter flex w-full flex-col items-center justify-center gap-2 @xl:flex-row @xl:items-end">
        <div className="flex min-h-7 flex-row flex-wrap gap-1.5 @lg:max-w-[450px] @xl:order-2 @2xl:max-w-[500px]">
          {seatBlocks}
        </div>
        <div className="mt-3 flex w-full grow flex-row flex-wrap items-start justify-start gap-3 pt-3 text-left font-medium md:flex-col md:gap-0 @lg:mt-0 @lg:shrink-0 @lg:basis-[140px] @xl:order-1">
          {data
            .filter(party => party.seats > 0)
            .map(row => (
              <div
                className="flex flex-row items-center justify-start gap-1"
                key={row.id}>
                <div
                  className="size-[15px] shrink-0 rounded-xs"
                  style={{ backgroundColor: `#${row.color}` }}
                />
                <SvText i18nKey={row.nameKey} className="font-semibold">
                  : <span className="font-medium">{row.seats}</span>
                </SvText>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
